import api from '../../utils/api';

export const removeProperty = (id: number) =>
  api.delete({
    url: `/property/${id}`,
  });
